var map = {
	"./news (1).jpeg": 3082,
	"./news (10).jpeg": 7416,
	"./news (11).jpeg": 5109,
	"./news (12).jpeg": 3386,
	"./news (13).jpeg": 1111,
	"./news (14).jpeg": 2644,
	"./news (15).jpeg": 5361,
	"./news (16).jpeg": 5734,
	"./news (2).jpeg": 3269,
	"./news (3).jpeg": 6632,
	"./news (4).jpeg": 2067,
	"./news (5).jpeg": 662,
	"./news (6).jpeg": 7086,
	"./news (7).jpeg": 9892,
	"./news (8).jpeg": 6783,
	"./news (9).jpeg": 8210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4248;